import React, { useRef } from "react";

import { css } from "@emotion/react";

import { ReactComponent as MailSvg } from "../../../assets/icons/Icon/DKT/mail-icon-trimmed.svg";
import { ReactComponent as ArrowSvg } from "../../../assets/icons/Icon/DKT/thin-arrow.svg";

import { CSS_MQ } from "../../../styles/breakpoints";
import { FooterData } from "@swo/storefront";
import { useNavigate, useLocation } from "react-router";
import { MAIL_LINK_FRAGMENT } from "../../../layouts/newsletter-landing-page-layout/mail-link-fragment";
import { FONTS, fontSize } from "../../../styles/fonts";
import { CSS_COLORS } from "../../../styles/styles-css-variables";
import { useStore } from "../../../store/hooks/use-store";

export const FooterNewsletter: React.FC<FooterData["newsletter"]> = props => {
  const navigate = useNavigate();
  const location = useLocation();
  const ref = useRef<HTMLInputElement | null>(null);

  const isNewsletterEnabled = useStore().state.config.newsletter.isNewsletterShown;

  function onSubmit(e: React.FormEvent) {
    e.preventDefault();

    const email = ref.current?.value;

    if (location.pathname === props.pageLink) {
      return window.location.reload();
    }

    if (email) {
      void navigate(
        { pathname: props.pageLink, hash: `${MAIL_LINK_FRAGMENT}${email}` },
        {
          state: { scrollToTop: true },
        },
      );
    } else {
      void navigate({ pathname: props.pageLink }, { state: { scrollToTop: true } });
    }
  }

  if (!isNewsletterEnabled) {
    return null;
  }

  return (
    <div
      css={css`
        color: ${CSS_COLORS.White};

        ${CSS_MQ.atLeastMd} {
          margin-bottom: 30px;
        }

        ${CSS_MQ.atMostSm} {
          margin-bottom: 30px;
        }
      `}
    >
      <span css={seoHeadlineStyles}>{props.seoHeadline.value}</span>
      <span css={emoHeadlineStyles}>{props.emoHeadline.value}</span>
      <form
        onSubmit={onSubmit}
        css={css`
          position: relative;
          display: flex;
        `}
      >
        <div
          css={css`
            position: absolute;
            width: 56px;
            height: 100%;

            display: flex;
            align-items: center;
            justify-content: center;
          `}
        >
          <MailSvg
            css={css`
              width: 20px;
            `}
          />
        </div>
        <input css={inputFieldStyles} placeholder={props.placeholder.value} type={"email"} ref={ref} required={false} />
        <button css={buttonLabel} type={"submit"} title={"Subscribe"}>
          <ArrowSvg
            css={css`
              color: ${CSS_COLORS.Green};
            `}
          />
        </button>
      </form>
    </div>
  );
};

const seoHeadlineStyles = [
  FONTS.SwarovskiFutura300,
  fontSize.x2,
  css`
    max-width: 32em;
    margin: 0;
    display: block;
  `,
];

const emoHeadlineStyles = [
  FONTS.MinervaModern500,
  fontSize.x4,
  css`
    margin: 0;

    display: block;

    margin-bottom: 20px;

    text-transform: uppercase;
  `,
];
const inputFieldStyles = css`
  height: 50px;

  ${CSS_MQ.atMostSm} {
    width: 100%;
  }

  width: 25em;
  max-width: 100%;

  border: 1px solid white;
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;

  border-top-right-radius: 0; // safari ios
  border-bottom-right-radius: 0; // safari ios

  background: transparent;

  padding-left: 56px;
  padding-top: 4px; // visual centering

  &:focus {
    outline: none !important;
  }

  &,
  &::placeholder {
    color: ${CSS_COLORS.White};

    ${FONTS.MinervaModern500};
    font-size: 16px;
  }
`;
const buttonLabel = css`
  background-color: ${CSS_COLORS.White};

  ${CSS_MQ.atMostSm} {
    width: 80px;
  }

  width: 100px;
  height: 50px;

  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;

  display: flex;
  justify-content: center;
  align-items: center;

  svg {
    width: 100%;
  }
`;
